<template>
    <OverlayLoader :isLoading="!feedsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.feeds')"
                />

                <WhiteTable :labels="[$translate.text('clients.feeds.name')]">
                    <template slot="table-data">
                        <tr v-for="feed in feeds" :key="feed.id">
                            <td>{{ feed.name }}</td>
                            <td class="align-right">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Feeds Edit', params: { id: feed.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-random" @click="$router.push({ name: 'Clients Feeds Combine', params: { id: feed.id } })" v-tooltip.bottom="$translate.text('tooltip.combine')"></i>
                                <i class="fal fa-trash-alt" @click="deleteFeed(feed.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                            </td>
                        </tr>
                        <tr v-if="!feeds.length">
                            <td colspan="3">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Clients Feeds Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import { get, remove } from '@/helpers/http';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';

export default {
    name: 'ClientsFeeds',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            feeds: [],
            feedsLoaded: false,
        };
    },

    created() {
        this.getFeeds();
    },

    methods: {
        getFeeds() {
            get({
                url: `${this.$API_URL}/api/clients/feeds`,
            })
                .then((response) => {
                    this.feeds = response.data.data;
                    this.feedsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deleteFeed(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    remove({
                        url: `${this.$API_URL}/api/clients/feeds/${id}`,
                    })
                        .then(() => {
                            this.getFeeds();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },
    },
};
</script>
